__turbopack_context__.v({
  "container": "espBSW_container",
  "icon": "espBSW_icon",
  "item": "espBSW_item",
  "label": "espBSW_label",
  "link": "espBSW_link",
  "themeSwitcher": "espBSW_themeSwitcher",
  "variant--patreon": "espBSW_variant--patreon",
});
